<template>
  <Navbar :title="NavbarTitle" :rightBtn="true"></Navbar>
  <div class="policy-detail">
    <!-- <policy-detail-header :detail="detail" :type="btnType"></policy-detail-header> -->
    <img class="img" src="@/assets/images/policy_match.png" />
    <div class="header">
      <div class="title small">
        <div
          class="level"
          v-if="detail.policy_level && detail.policy_level == 0"
        >
          [国]
        </div>
        <div
          class="level"
          v-if="detail.policy_level && detail.policy_level == 1"
        >
          [省]
        </div>
        <div
          class="level"
          v-if="detail.policy_level && detail.policy_level == 2"
        >
          [市]
        </div>
        <div
          class="level"
          v-if="detail.policy_level && detail.policy_level == 3"
        >
          [区县]
        </div>
        <div
          class="level"
          v-if="detail.policy_level && detail.policy_level > 3"
        >
          [其他]
        </div>
        <div>{{ detail.title }}</div>
      </div>
      <div class="origin" v-if="detail.article && detail.article.origin">
        来源：{{ detail.article.origin }}
      </div>
      <div class="match-detail small">
        <div class="field-normal">
          <div class="field-item">
            <span class="field-label">阅读量:</span>
            <span class="field-value">{{ detail.click_num || 0 }}</span>
          </div>
          <div class="field-item">
            <span class="field-label">收藏量:</span>
            <span class="field-value">{{ detail.favorite_num }}</span>
          </div>
          <div class="field-item" v-if="btnType != '1' && detail.prepareDate">
            <span class="field-label">发文日期:</span>
            <span class="field-value">{{ detail.prepareDate }}</span>
          </div>
          <div class="field-item" v-if="btnType != '1' && detail.releaseDate">
            <span class="field-label">文章日期:</span>
            <span class="field-value">{{ detail.releaseDate }}</span>
          </div>
          <div
            class="field-item"
            v-if="btnType != '1' && detail.article && detail.article.dispatch"
          >
            <span class="field-label">发文批号:</span>
            <span class="field-value">{{ detail.article.dispatch }}</span>
          </div>
          <div
            class="field-item address"
            v-if="detail.article && detail.article.dispatch_name"
          >
            <span class="field-label"> 发文部门:</span>
            <span class="field-value">{{ detail.article.dispatch_name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-for="item in items" :key="item.title">
      <div v-if="item.content">
        <div class="card-title">
          <div class="flex-title-text">
            {{ item.title }}
          </div>
        </div>
        <div class="card-content card-content-html" v-if="item.content">
          <div v-html="item.content"></div>
        </div>
      </div>
    </div>
    <div class="card" v-if="detail.source">
      <div class="card-title">
        <div class="flex-title-text">文章来源</div>
      </div>
      <div class="card-content">
        <div>
          <a :href="detail.source" target="_blank">{{ detail.title }}</a>
        </div>
      </div>
    </div>

    <div class="article-kv-card" v-for="item in articleKvList" :key="item">
      <div class="article-kv-card-title" style="margin: 0; padding-bottom: 0" v-if="item.key && item.key.replace('：','').length > 1">
        {{ item.key }}
      </div>
      <div style="margin: 0; padding: 0 0.4rem 0.4rem">
        <div class="article-kv-card-content" v-for="v in item.value" :key="v">
          <div  v-if="v && v.length > 1">{{ v }}</div>
        </div>
        <div v-if="item.children && item.children.length">
          <div v-for="k in item.children" :key="k">
            <div style="font-weight: bold; padding: 18px 0 8px" v-if="k.key && k.key.replace('：','').length > 1">{{ k.key }}</div>
            <div
              class="article-kv-card-content"
              v-for="v in k.value"
              :key="v"
              style="margin: 0; line-height: 1.8"
            >
               <div  v-if="v && v.length > 1">{{ v }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="appendix.length">
      <div class="card-title">
        <div class="flex-title-text">附件</div>
      </div>

      <div class="card-content">
        <div v-for="item in appendix" :key="item">
          <a :href="item.contentView" target="_blank">{{ item.name }}</a>
        </div>
      </div>
    </div>

    <div class="card" v-if="similar.length">
        <Similar :similar="similar"></Similar>
      </div>

  </div>

  <div class="float-action">
    <div class="flex-item btn-collect-box" v-if="btnType != '2'">
      <van-button
        class="btn btn-collect btn-favorite"
        v-if="!favorite"
        @click="doFav(true)"
      >
        <img
          class="icon-favorite"
          src="@/assets/images/icon_favorite_1@2x.png"
        />
        收藏
      </van-button>
      <van-button class="btn btn-favorite-active" v-else @click="doFav(false)">
        <img
          class="icon-favorite"
          src="@/assets/images/icon_favorite_2@2x.png"
        />

        取消收藏
      </van-button>
    </div>
    <div
      class="flex-item btn-consult-box"
      v-if="btnType == '1' && detail.status == '1'"
    >
      <van-button class="btn btn-consult" @click="doDeclare">
        <van-icon class="icon" name="chat-o" color="#fff" size="20" />
        一键申报
      </van-button>
    </div>
    <div class="flex-item btn-consult-box" v-if="btnType == '2'">
      <van-button class="btn" type="danger" @click="doTel"
        >联系服务商</van-button
      >
    </div>
  </div>
</template>

<script>
import { Dialog, Notify } from "vant";
import {
  queryById,
  queryOrderById,
  getServiceProviderList,
  addFavorite,
  cancelFavorite,
  queryFavorite,
  queryUserById,
  queryPolicyInfo,
  getArticleKvV3,
  getArticleSimilarV3
} from "@/api/home";
import moment from "moment";
import { info, cache, ws } from "@/api";
import Select from "@/components/Select.vue";
import SearchDetail from "@/components/SearchDetail.vue";
import Date from "@/components/Date.vue";
import Area from "@/components/Area.vue";
import Navbar from "@/components/Navbar";
import PolicyDetailHeader from "@/components/PolicyDetailHeader.vue";
import DeclareModel from "@/components/DeclareModel";
import { clickUrlToPhone } from "@/utils/index";
import { getUserInfo, getUserId } from "@/utils/storage";
import store from "@/store";
import Similar from "./comp/similar.vue"

export default {
  data() {
    return {
      detail: {
        serviceProviderTel: "",
      },
      items: [],
      declareShow: false,
      formCompany: {},
      showCompany: false,
      declareList: [],
      NavbarTitle: "政策文件详情",
      btnType: 0,
      favorite: false,
      queryCompany: {},
      company: {},
      appendix: [],
      articleKvList: [],
      similar: []//相似文件
    };
  },
  components: {
    Select,
    SearchDetail,
    Date,
    Area,
    Navbar,
    PolicyDetailHeader,
    DeclareModel,
    Similar
  },
  computed: {},
  watch: {},
  mounted() {
    this.init();
  },
  watch: {},
  methods: {
    moment,
    init() {
      this.id = this.$route.query.id;
      this.btnType = this.$route.query.btnType;
      this.type = this.$route.query.type || "";
      this.articleId = this.$route.query.articleId;
      this.getData();
      this.getArticleKv();
    },
    async doFav(type) {
      const request = type ? addFavorite : cancelFavorite;
      let res = await request({ policy_id: this.id });
      this.$toast.success({
        message: type ? "收藏成功" : "取消收藏成功",
        duration: 2000,
      });
      setTimeout(() => {
        this.getData();
      }, 2000);
    },
    async getData() {
      let res = await queryPolicyInfo({
        id: this.id,
        articleId: this.articleId,
      });
        this.detail = res.result || {};
      if (res.result.title) {
            this.getArticleSimilar(res.result.title)
        }
      this.appendix = res.result.appendix.map((o) => {
        return {
          ...o,
          contentView: location.origin + "/" + o.content,
        };
      });
      this.detail.source = res.result.article.source;
      this.detail.policy_level = res.result.article.policy_level;
      this.detail.prepareDate =
        res.result.article && res.result.article.release_time
          ? moment(res.result.article.release_time).format("YYYY-MM-DD")
          : "";
      this.detail.releaseDate =
        res.result.article && res.result.article.time
          ? moment(res.result.article.time).format("YYYY-MM-DD")
          : "";
      this.favorite = res.result.favorite ? true : false;
      this.items = [
        { title: "核心内容", content: res.result.article.content },
        // { title: '扶持条件', content: res.result.article.support_conditions },
        // { title: '申报材料', content: res.result.article.filing_materials },
        // { title: '申报流程', content: res.result.article.declaration_process },
        // { title: '联系方式', content: res.result.article.contact_phone },
        // { title: '政策文件', content: res.data.dispatchDepartment }
      ];
    },
    async getArticleKv() {
      try {
        let res = await getArticleKvV3({
          id: this.articleId,
        });
        this.articleKvList = this.getArticleKvList(res.result, []);
        console.log(this.articleKvList);
      } catch {}
    },
    getArticleKvList(data, arr) {
      for (var i in data) {
        let obj = {
          key: data[i].key,
          children: [],
          value: data[i].value,
        };
        if (data[i].children) {
          this.getArticleKvList(data[i].children, obj.children);
        }
        arr.push(obj);
      }
      return arr;
      },
    async getArticleSimilar(title) {
          try {
              let res = await getArticleSimilarV3({ title: title })
              this.similar = res.result || []
          } catch {
              
          }
    }
  },
  beforeRouteLeave(to, from, next) {
    // 离开的时候，非以下页面则删除缓存组件 name
    // 记录路由处的name值
    let coms = ["PolicyQuery"];
    console.log(coms.indexOf(to.name) === -1, to.name);
    if (coms.indexOf(to.name) === -1) {
      for (var i in coms) {
        store.commit("REMOVE_KEEP_ALIVE_COM", coms[i]);
      }
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.policy-detail {
  padding-bottom: 100px;
}
.flex-item .btn {
  width: 100%;
  height: 60px;
}

.wrap-box-title {
  padding: 0 13px;
  font-size: 16px;
  font-weight: 600;
  color: #006d9b;
  line-height: 19px;

  &.wrap-box-d {
    margin: 20px 0;
    border-radius: 8px;
    padding: 10px 0 15px;

    .card-title {
      &:before {
        width: 4px;

        border-left: 4px solid #f3b30e;
      }
    }
  }
}
.origin {
  color: #fff;
  font-size: 12px;
  margin: 3px 10px 5px;
}

.origin {
  color: #fff;
  font-size: 12px;
  margin: 3px 10px 5px;
}
.level {
  flex-shrink: 0;
}
.title-samll {
  justify-content: space-around;
}

.article-kv-card {
  width: auto;
  margin: 0 0 15px;
  background: #fff;
  border-radius: 8px;
  > div {
    padding: 10px 15px;
  }
  .article-kv-card-title {
    margin: 0;
    font-size: 14px;
    &:before {
      content: '';
      height: 16px;
      margin-right: 5px;
      border-left: 4px solid #0c9de9;
    }
    &:first-of-type {
      border: 0;
    }
  }
  .article-kv-card-content {
    margin: 10px 0 0;
    padding: 0;
    color: #666;
  }
}
</style>
